import angular, {
  ICompileService,
  IDirective,
  ITemplateCacheService,
  ITemplateLinkingFunction,
} from "angular";
import { ProcessDetailViewController } from "../controller";

export const vsDirectiveName = "workflowItemWrapper";

type LinkingFunctionCache = {
  [type: string]: ITemplateLinkingFunction | undefined;
};

export function workItemWrapperDirective(
  $templateCache: ITemplateCacheService,
  $compile: ICompileService
): IDirective {
  const linkingFunctions: LinkingFunctionCache = {};

  return {
    template: "<span></span>",
    scope: {
      stateController: "<",
      workflowItem: "<",
    },
    link: {
      pre: (s, element, attrs, ctrl, transclude) => {
        const scope: any = s;

        const linkingFunction = getLinkingFunction(
          scope.stateController,
          scope.workflowItem.Type,
          $compile,
          $templateCache,
          linkingFunctions
        );

        element.append(
          linkingFunction(scope, (_, cloneScope) => {
            (<any>cloneScope).viewData = {};
          })
        );
      },
    },
  };
}
workItemWrapperDirective.$inject = ["$templateCache", "$compile"];

function getLinkingFunction(
  stateController: ProcessDetailViewController,
  workflowItemType: string,
  $compile: ICompileService,
  $templateCache: ITemplateCacheService,
  linkingFunctions: LinkingFunctionCache
) {
  const cachedLinkingFunction = linkingFunctions[workflowItemType];

  if (cachedLinkingFunction !== undefined) {
    return cachedLinkingFunction;
  }

  const templateUrl = stateController.getTemplateUrl(workflowItemType);
 
  const template = $templateCache.get<string>(templateUrl);
  const workitemElement = angular.element(
    template ?? "<span>No Template found</span>"
  );

  return (linkingFunctions[workflowItemType] = $compile(workitemElement));
}
